<div class="terminated-dialog">
  <div class="icon-wrapper">
    <i class="bi bi-exclamation-octagon-fill"></i>
  </div>

  <h2 mat-dialog-title>Interview Terminated</h2>

  <div mat-dialog-content>
    <p class="message">You have reached the violations limit, and we are ending your interview at this point.</p>

    <div class="reason-container" *ngIf="reason">
      <span class="reason-label">Termination Reason</span>
      <span class="reason-text">{{ formattedReason }}</span>
    </div>
  </div>

  <div mat-dialog-actions align="center" class="actions">
    <button mat-flat-button (click)="onOkay()" class="okay-btn">Okay</button>
  </div>
</div>